import { useSelector } from 'react-redux';
import { updateSelector } from '../../wave/selectors/update.selectors';
import { waveForIdSelector } from '../../wave/selectors/wave.selectors';
import { WaveId } from '../../wave/types/wave.type';
import { getUpdatedWave } from '../../wave/utils/wave.util';
import { useStrip } from '../hooks/useStrip';
import { StripSquare } from './StripSquare';
import { exactDurationSelector } from '../../ecg/selectors/ecg.selectors';

interface Props {
  waveId: WaveId;
  count: number;
}

export const WaveCount = ({ waveId, count }: Props) => {
  const baseWave = useSelector(waveForIdSelector(waveId));
  const linkedWave = useSelector(waveForIdSelector(baseWave?.link?.waveId));
  const update = useSelector(updateSelector);
  const ecgDuration = useSelector(exactDurationSelector);

  const { onset: startingOnset } = useStrip();
  if (baseWave == null) {
    return null;
  }

  const { onset, offset } = getUpdatedWave(
    baseWave,
    update,
    ecgDuration,
    linkedWave,
  );

  return (
    <StripSquare onset={onset + startingOnset} offset={offset}>
      <text>{count}</text>
    </StripSquare>
  );
};
